import React from "react"
import { connect } from "react-redux"
import DocumentTitle from "react-document-title"
// app
import UserSignUp from "components/user/SignUp"
import ThankYou from "components/user/SignUp/thank-you"
import { signup } from "actions/user/actions.js"


class SignUp extends React.Component {
    constructor(props) {
        super()

        this.save = this.save.bind(this)
    }

    save(user) {
        this.props.signup(user)
    }

    render() {
        const { saved } = this.props

        return <DocumentTitle title={ saved === true ? "Thank You" : "Sign Up" }>
                <div className="page">
                    <div className="row">
                        <div className="col-xs-12">
                            { saved === true ?
                                <ThankYou />
                                :
                                <UserSignUp
                                    onSave={ this.save }
                                />
                            }
                        </div>
                    </div>
                </div>
            </DocumentTitle>
    }
}

function mapDispatchToProps(dispatch) {
    return {
        signup: user => dispatch(signup(user))
    }
}

function mapStateToProps(state) {
    return {
        saved: state.user.get("signedup", false)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp)


/** WEBPACK FOOTER **
 ** ./src/containers/SignUp/signup.js
 **/